import React, { useState, useMemo, useEffect } from "react";
import Select from 'react-select'

function TeamRegistrationForm({state, service, index}) {
    const registration = state.applications[index];

    const handleStateChange = (property, eventObject) => {
        service.handleStateChange(index, property, typeof eventObject === 'object' ? eventObject.target.value : eventObject);
    }

    const [countryOptions, setCountryOptions] = useState()

    useEffect(() => {
        let active = true
        loadCountries()
        return () => { active = false }

        async function loadCountries() {
            const res = await service.getCountryOptions()
            if (!active) { return }
            setCountryOptions(res)
        }

    }, []);


    const [clubOptions, setClubOptions] = useState()

    useEffect(() => {
        let active = true
        load()
        return () => { active = false }

        async function load() {
            const res = await service.getClubOptions()
            if (!active) { return }
            setClubOptions(res)
        }
    }, [])


    return (
        <>
            <h2>Person {index + 1}</h2>
            <p>
                <input className="nameInput" type="text" name="firstname" placeholder="Förnamn"
                       value={registration.firstName}
                       onChange={(e) => {
                           handleStateChange('firstName', e)
                       }} onKeyUp={(e) => {
                    service.handleKeyPress(e)
                }}/>&nbsp;&nbsp;
                <input className="nameInput" type="text" name="lastname" placeholder="Efternamn"
                       value={registration.lastName}
                       onChange={(e) => {
                           handleStateChange('lastName', e)
                       }} onKeyUp={(e) => {
                    service.handleKeyPress(e)
                }}/>
            </p>

            <p>
                <Select placeholder="Ange klubb" options={clubOptions} isClearable
                        value={registration.clubObject}
                        onChange={(c) => {
                            service.handleStateChange(index, 'clubObject', c)
                        }} onKeyUp={(e) => {
                    service.handleKeyPress(e)
                }}/>
            </p>
            <p>
                <input className="clubInput" type="text" name="club" placeholder="eller ort* om ej klubbmedlem"
                       size={31}
                       disabled={registration.disableClubInput}
                       value={registration.clubInput} onChange={(e) => {
                    handleStateChange('clubInput', e)
                }} onKeyUp={(e) => {
                    service.handleKeyPress(e)
                }}/>
            </p>

            <input type="number" name="birthyear" placeholder="Födelseår" value={registration.birthyear}
                   onChange={(e) => {
                       handleStateChange('birthyear', e)
                   }} step="1" size="8"
                   onKeyUp={(e) => {
                       service.handleKeyPress(e)
                   }}/>
            &nbsp;{registration.birthyear.length != 4 ? '' : (service.isAdult(registration.birthyear) ? 'Vuxen' : 'Ungdom')}
            <p>
                <input type="radio" id={"male" + index}
                       name={"gender" + index}
                       value="male"
                       checked={registration.gender === 'male'}
                       onChange={(e) => {
                           handleStateChange('gender', e)
                       }} onKeyUp={(e) => {
                    service.handleKeyPress(e)
                }}/> <label htmlFor={"male" + index}>Man</label>
                &nbsp;&nbsp;&nbsp;
                <input type="radio" id={"female" + index}
                       name={"gender" + index}
                       value="female"
                       checked={registration.gender === 'female'}
                       onChange={(e) => {
                           handleStateChange('gender', e)
                       }} onKeyUp={(e) => {
                    service.handleKeyPress(e)
                }}/> <label htmlFor={"female" + index}>Kvinna</label>
            </p>

            <Select options={countryOptions} value={registration.countryObject} onChange={(c) => {
                service.handleStateChange(index, 'countryObject', c)
            }} onKeyUp={(e) => {
                service.handleKeyPress(e)
            }}/>

            <br/>
            <p>
                <input type="checkbox" id={'bus' + index} disabled={!service.isBussApplyOpen(index)} onChange={(e) => {
                    handleStateChange('bus', e.target.checked)
                }}
                       onKeyUp={(e) => {
                           service.handleKeyPress(e)
                       }}/> <label htmlFor={'bus' + index}>{service.getBusLabel(index)}</label> <span
                style={{float: "right"}}>{state.competition.busFee}&nbsp;kr</span>
            </p>
            <p>
                <input type="checkbox" id={'noPhoto' + index} onChange={(e) => {
                    handleStateChange('noPhoto', e.target.checked)
                }}
                       onKeyUp={(e) => {
                           service.handleKeyPress(e)
                       }}/> <label htmlFor={'noPhoto' + index}>Vill ej vara med på bild.**</label>
            </p>
        </>
    );
}

export default TeamRegistrationForm;